import { MdgpDbApiProxyRef, IncompleteRequest } from '../api';
import {
  Table,
  TableColumn,
  Breadcrumbs,
  Link,
  Progress,
  ResponseErrorPanel,
  Header,
  HeaderLabel,
  Page,
  Content,
} from '@backstage/core-components';
import useAsync from 'react-use/lib/useAsync';
import { useApi } from '@backstage/core-plugin-api';
import { Grid } from '@material-ui/core';

type IncompleteRequestsTableProps = {
  incompleteRequests: IncompleteRequest[];
};

export const IncompleteRequestsTable = ({ incompleteRequests }: IncompleteRequestsTableProps) => {
  const columns: TableColumn[] = [
    { title: 'Request ID', field: 'request_id' },
    { title: 'Request Type', field: 'request_type' },
    { title: 'Request Received Timestamp', field: 'request_received_timestamp' },
    { title: 'System Name', field: 'system_name' },
    { title: 'System Contact', field: 'system_contact' },
  ];

  return (
    <Page themeId="tool">
      <Header title="MDGP Dashboard" subtitle="Shows current information about the Move Data Governance Pipeline">
        <HeaderLabel label="Owner" value="TBD" />
        <HeaderLabel label="Slack" value="TBD" />
      </Header>
      <Content>
        <Grid container spacing={3} direction="column">
          <Grid item>
            <Breadcrumbs>
              <Link to="/mdgp-dashboard">Home</Link>
            </Breadcrumbs>
          </Grid>
          <Grid item>
            <Table
              title="Current Incomplete CCPA Requests"
              options={{ search: false, paging: false }}
              columns={columns}
              data={incompleteRequests}
            />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};

export const IncompleteRequestsComponent = ({ mockData }: any) => {
  const apiClient = useApi(MdgpDbApiProxyRef);
  const { value, loading, error } = useAsync(async () => {
    if (mockData !== undefined) {
      return mockData.data;
    }

    return apiClient.get<IncompleteRequest[]>('mdgp-db-api/incomplete_requests');
  }, []);

  if (loading) {
    return <Progress />;
  } else if (error) {
    return <ResponseErrorPanel error={error} />;
  }

  return <IncompleteRequestsTable incompleteRequests={value || []} />;
};
